import request from '@/utils/request'


// 出库申请信息添加
export function addOutApply(data) {
    return request({
        url: '/db/outbound-apply-info/add',
        method: 'post',
        data
    })
}

// 出库申请信息-通过
export function auditPass(data) {
    return request({
        url: '/db/outbound-apply-info/audit-pass',
        method: 'put',
        params: data
    })
}

// 出库申请信息-拒绝
export function auditRefuse(data) {
    return request({
        url: '/db/outbound-apply-info/audit-refuse',
        method: 'put',
        params: data
    })
}

//详情查询
export function queryDetails(data) {
    return request({
        url: '/db/outbound-apply-info/details',
        method: 'get',
        params: data
    })
}

//出库发货
export function confirmDelivery(data) {
    return request({
        url: '/db/outbound-apply-info/confirmDelivery',
        method: 'put',
        data
    })
}

//分页列表查询
export function pageQuery(data) {
    return request({
        url: '/db/outbound-apply-info/query',
        method: 'post',
        data
    })
}

//出库记录信息查询
export function queryOutInfo(data) {
    return request({
        url: '/db/outbound-apply-info/queryOutInfo',
        method: 'post',
        data
    })
}

//物料查询
export function queryMaterialList(data) {
    return request({
        url: '/db/entry-details-info/queryMaterialList',
        method: 'post',
        data
    })
}


// 出库记录一键导出
export function reportExport(data) {
    return request({
        url: '/db/outbound-apply-info/outbound-record-report-export',
        method: 'post',
        data
    })
}

// 导出查询
export function queryOutboundRecordExportInfo(data) {
    return request({
        url: '/db/outbound-apply-info/query-outbound-record-export-info/' + data,
        method: 'GET',
    })
}


// 修改出库物料信息
export function updMaterialsInfo(data) {
    return request({
        url: '/db/outbound-apply-info/upd-materials-info',
        method: 'post',
        data
    })
}

// 校验工单号
export function checkMtcSeq(data) {
    return request({
        url: '/db/outbound-apply-info/check-eqp-mtc/' + data,
        method: 'get',
    })
}
